import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import { auth } from "./FirebaseConfig";
import Navbar from "./components/Navbar";
import Checkout from "./pages/Checkout";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Order from "./pages/Order";
import Admin from "./pages/Admin";
import { useState } from "react";
import LoginInAdmin from "./pages/LoginInAdmin";
import { signInWithEmailAndPassword } from "firebase/auth";
import Cart from "./pages/Cart";
import festive from './assets/Festival'
import Jumia from "./assets/Jumia";
import LearnMore from "./pages/LearnMore";
import snow from "./assets/Snow";
import Product from "./pages/Product";
import Checkin from "./pages/Checkin";

function App() {
  const [bought, setBought] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cartNo, setCartNo] = useState(0);
  const [error, setError] = useState(null);
  const [isAuth, setIsAuth] = useState(false);
  
  const navigate = useNavigate();

  
  const handleEmailandPassword = async (e) => {
    e.preventDefault();
    try {
       await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("isAuth", true);
      setIsAuth(true);
      navigate("/Admin101");
    } catch (err) {
      setError(err.message);
    }
  };


  return (
    <div className="App">
      <Navbar 
      cartNo={cartNo}
      />
            <div className='flex lg:hidden fixed top-4 right-2 p-3'>
           <img src={festive} alt="logo for christmas" className='h-[80px]'/>
          </div>
          <div className='flex lg:hidden fixed top-7 right-2 p-3'>
           <img src={snow} alt="logo for christmas" className='h-[180px]'/>
          </div>
      <Routes>
        <Route
          path="/"
          element={<Home setBought={setBought} bought={bought} />}
        />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/checkout"
          element={
            <Checkout
            setCartNo={setCartNo}
            cartNo={cartNo}
            />
          }
        />
         <Route
          path="/checkin"
          element={
            <Checkin
            setCartNo={setCartNo}
            cartNo={cartNo}
            />
          }
        />
        <Route path="/Order" element={<Order />} />
        <Route path="/Admin101/LoginPage" element={<LoginInAdmin 
        isAuth={isAuth}
        setIsAuth={setIsAuth}
        handleEmailandPassword={handleEmailandPassword}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        error={error}

        />} />
        <Route path="/Admin101" element={<Admin 
        isAuth={isAuth}
        setIsAuth={setIsAuth}
        handleEmailandPassword={handleEmailandPassword}
        email={email}
        />} />
        <Route path="/cart" element={<Cart 
        isAuth={isAuth}
        setIsAuth={setIsAuth}
        handleEmailandPassword={handleEmailandPassword}
        email={email}
        />} />
         <Route path="/Order2" element={<Product 
        isAuth={isAuth}
        setIsAuth={setIsAuth}
        handleEmailandPassword={handleEmailandPassword}
        email={email}
        />} />
        <Route path="/learnMore" element={<LearnMore 
        isAuth={isAuth}
        setIsAuth={setIsAuth}
        handleEmailandPassword={handleEmailandPassword}
        email={email}
        />} />
      </Routes>
    </div>
  );
}

export default App;
